import { IconContainer, IconsContainer } from "./style";
import { ReactComponent as Twitter } from "../../../assets/icons/twitter.svg";
import { ReactComponent as Github } from "../../../assets/icons/github.svg";
import { ReactComponent as LinkedIn } from "../../../assets/icons/linkedin.svg";
import { ReactComponent as Mail } from "../../../assets/icons/email.svg";
import config from "../../../config";

function SocialIconsBar() {
  return (
    <IconsContainer>
      <IconContainer>
        <a href={config.social.twitter} target="_blank" rel="noreferrer">
          <Twitter />
        </a>
      </IconContainer>
      <IconContainer>
        <a href={config.social.github} target="_blank" rel="noreferrer">
          <Github />
        </a>
      </IconContainer>
      <IconContainer>
        <a href={config.social.linkedin} target="_blank" rel="noreferrer">
          <LinkedIn />
        </a>
      </IconContainer>
      <IconContainer>
        <a href={`mailto:${config.social.mail}`}>
          <Mail />
        </a>
      </IconContainer>
    </IconsContainer>
  );
}

export default SocialIconsBar;
